import { createJSONStorage, type PersistStorage } from 'zustand/middleware';

/**
 * Armazenamento persistente que não se queixa quando não existe.
 *
 * Nos testes unitários não há `localStorage`, e o `persist` do zustand escreve
 * um aviso por cada escrita. Dezenas de linhas de aviso numa execução verde
 * treinam quem lê a ignorar a saída dos testes — e depois passa despercebido o
 * aviso que importava.
 *
 * O mesmo se aplica em produção: um navegador em modo privado com o
 * armazenamento bloqueado não pode fazer a aplicação deixar de funcionar. O
 * progresso perde-se ao fechar, que é mau, mas a lição corre.
 */
function disponivel(): boolean {
  try {
    return typeof localStorage !== 'undefined';
  } catch {
    // Aceder a `localStorage` lança em alguns navegadores com cookies
    // bloqueadas, em vez de devolver `undefined`.
    return false;
  }
}

const emMemoria = new Map<string, string>();

export function armazenamento<T>(): PersistStorage<T> | undefined {
  return createJSONStorage<T>(() =>
    disponivel()
      ? localStorage
      : {
          getItem: (chave) => emMemoria.get(chave) ?? null,
          setItem: (chave, valor) => void emMemoria.set(chave, valor),
          removeItem: (chave) => void emMemoria.delete(chave),
        },
  );
}
